"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledNestedNavigationItem = exports.StyledNestedNavigationItemIcon = exports.StyledNestedNavigationItemTitle = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const buttonReset_styles_1 = require("../../../DesignSystem/styles/buttonReset.styles");
const helpers_1 = require("../../../helpers");
const Icon_1 = require("../../../Icon");
const Text_1 = require("../../../Text");
exports.StyledNestedNavigationItemTitle = (0, styled_components_1.default)(Text_1.Text) ``;
exports.StyledNestedNavigationItemIcon = (0, styled_components_1.default)(Icon_1.Icon) ``;
exports.StyledNestedNavigationItem = styled_components_1.default.button `
    ${buttonReset_styles_1.buttonReset};
    display: flex;
    align-items: center;
    min-width: 0; // for text truncation
    max-width: 600px;
    height: 100%;
    max-height: ${helpers_1.SIZE_XL};
    padding-right: ${helpers_1.SPACING_M};
    padding-left: ${helpers_1.SPACING_M};

    ${({ theme }) => (0, styled_components_1.css) `
        background-color: ${theme.colorBackgroundBlank};
    `}

    ${({ disabled }) => !disabled &&
    (0, styled_components_1.css) `
            cursor: pointer;
        `}

    ${exports.StyledNestedNavigationItemTitle} {
        ${({ theme, disabled }) => {
    if (disabled) {
        return (0, styled_components_1.css) `
                    color: ${theme.colorTextTabDisabled};
                `;
    }
    return (0, styled_components_1.css) `
                color: ${theme.colorLink};
            `;
}}
    }

    ${({ theme, disabled, isActive }) => !disabled &&
    !isActive &&
    (0, styled_components_1.css) `
            &:hover {
                background-color: ${theme.colorHighlightLight};
            }

            &:focus-visible {
                background-color: ${theme.colorHighlightDark};
            }

            &:active {
                background-color: ${theme.colorAccent};

                ${exports.StyledNestedNavigationItemTitle} {
                    color: ${theme.colorTextRestButton};
                }
            }
        `}

    ${({ theme, disabled, isActive }) => !disabled &&
    isActive &&
    (0, styled_components_1.css) `
            background-color: ${theme.colorAccent};

            ${exports.StyledNestedNavigationItemTitle} {
                color: ${theme.colorTextRestButton};
            }
        `}
    
    ${exports.StyledNestedNavigationItemIcon} + ${exports.StyledNestedNavigationItemTitle} {
        margin-left: ${helpers_1.SPACING_S};
    }
`;
//# sourceMappingURL=NestedNavigationItem.styles.js.map